import { request } from "../../utils/http";

export const requestLoginToken = (email) =>
  request("/v1/auth/email/", { method: "POST", body: { email } });

export const validateLoginToken = (email, token) =>
  request("/v1/auth/token/", { method: "POST", body: { email, token } });
